import React from 'react';
import _get from 'lodash/get';
import { createRoot } from 'react-dom/client';
import Root from './components/RootDesktop';
import configureStore from './store/configureStoreDesktop';
import { getDesktopChunk, getCommonChunk } from './asyncImportList';
import getWebpackPublicPath from './utils/commonUtils';

import { init } from './utils/dataGrinch';
import { getParams, readQueryParameter, clearExpiredCartAttributionMap, clearAttributionToken, clearExpiredCopilotMap } from './utils/pageInfo';
import "./web-vitals-integration";
import './instrument.js';

if ('requestIdleCallback' in window) {
  requestIdleCallback(() => import('./initializeCopilot'), { timeout: 5000 });
} else {
  setTimeout(() => import('./initializeCopilot'), 5000);
}

const preloadedState = window.__PRELOADED_STATE__;
__webpack_public_path__ = getWebpackPublicPath();
const { store, persistor } = configureStore(preloadedState);

window.store = store;

clearExpiredCartAttributionMap();
clearAttributionToken();
clearExpiredCopilotMap();

const render = () => {
  init(getParams(location))
    .then(response => {
      const container = document.getElementById('app');
      const root = createRoot(container);
      root.render(<Root store={store} persistor={persistor}/>);
      // console.log("Successfully received the fingerprint of the device.");
    })
    .catch(error => {
      const container = document.getElementById('app');
      const root = createRoot(container);
      root.render(<Root store={store} persistor={persistor}/>);
      // console.log("Registration Failed");
    });
};

let { pathname = '' } = location;
let pathComponent = pathname.split('/');

let asyncComp = getDesktopChunk(pathComponent[1]);
let loginComp = getCommonChunk('auth');

if (loginComp) {
  loginComp.then(authModule => {
    window.authModule = authModule.default;
    if (asyncComp) {
      asyncComp.then(module => {
        window.loadedComponent = module.default;
        render();
      });
    } else {
      render();
    }
  });
} else {
  render();
}
